module.exports = __webpack_public_path__ + "media/packs/images/flags/FI-61d9f68f262dace8b6d62d2655fcee64.png";